import React from "react";

function ReferralFilter({ value, onChange }) {
  return (
    <div className="referral-filter">
      <label className="label-no-transform" htmlFor="referral">
        Accepts online service requests?
      </label>
      <input
        className="input referral-chk"
        name="referral"
        type="checkbox"
        id="referral"
        checked={value === "true" || value === true}
        onChange={(e) => onChange(e.target.checked ? "true" : null)}
      />
    </div>
  );
}

export default ReferralFilter;
